import { TProps } from './types/TProps';

const optionClassName = [
  'option block cursor-pointer px-[15px] py-2.5',
  'hover:bg-[var(--color-form-field-hover-overlay,rgba(0,0,0,0.06))]',
].join(' ');

const optionSelectedClassName = [
  'option option--selected block cursor-pointer px-[15px] py-2.5',
  'bg-[var(--color-form-field-select-option-selected-bg,var(--color-nav-active-bg))] hover:bg-[var(--color-form-field-select-option-selected-bg,var(--color-nav-active-bg))]',
].join(' ');

export const FormFieldSelectOption = ({ selected = false, className = '', children, ...rest }: TProps) => (
  <span
    className={[selected ? optionSelectedClassName : optionClassName, className].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </span>
);
